import React from 'react';
import { EDTextEdit } from '../../../../../../BaseComponents/TextEdit/EDTextEdit';
import EDRadioGroup, {
  IRadioDef,
} from '../../../../../../BaseComponents/RadioGroup/EDRadioGroup';
import { OnSubmitType, IFieldIssues } from '../../../../../../Types/FormTypes';
import { TEDUrvalVisibility } from '../../../../../../Types/UrvalTypes';
import EDForm from '../../../../../../BaseComponents/Forms/EDForm';
import Field from '../../../../../../BaseComponents/Forms/EDField';
import { TEDSelectionVisibility } from '../../../../../../globalQueryTypes';

interface IProps {
  setOKClick: (okClick: any) => void;
  initialValues: {
    name: string;
    visibility: TEDUrvalVisibility | null;
    description: string | null;
  };
  disableNameEdit?: boolean;
  onSubmit: OnSubmitType;
  setError?: (error: boolean) => void;
  availableVisibilityOptions: TEDUrvalVisibility[];
}

const visibilityOptionToRadioDef = (
  visibilityOption: TEDUrvalVisibility
): IRadioDef => {
  switch (visibilityOption) {
    case TEDSelectionVisibility.privat:
      return { value: TEDSelectionVisibility.privat, label: 'Mitt urval' };
    case TEDSelectionVisibility.gemensamt:
      return {
        value: TEDSelectionVisibility.gemensamt,
        label: 'Gemensamt urval',
      };
    case TEDSelectionVisibility.grupp:
      return { value: TEDSelectionVisibility.grupp, label: 'Grupp' };
    case TEDSelectionVisibility.ingen:
      return { value: TEDSelectionVisibility.ingen, label: 'Ingen' };
    case TEDSelectionVisibility.standard:
      return { value: TEDSelectionVisibility.standard, label: 'Standard' };
    case TEDSelectionVisibility.dbstandard:
      return {
        value: TEDSelectionVisibility.dbstandard,
        label: 'Standard grundurval',
      };
  }
};

/** Baskomponent för formulär vid skapning av nytt och redigering av sparat urval */
class SaveUrvalForm extends React.Component<IProps> {
  render() {
    return (
      <EDForm
        onSubmit={this.props.onSubmit}
        initialValues={this.props.initialValues}
      >
        {props => {
          this.props.setOKClick(props.submitForm);
          return (
            <React.Fragment>
              <Field
                name="name"
                validate={value => {
                  const fieldIssues: IFieldIssues = {
                    errors: [],
                    warnings: [],
                  };
                  if (!value) {
                    fieldIssues.errors.push({
                      id: 'noInput',
                      message: 'Måste ange värde',
                    });
                  }

                  if (this.props.setError) {
                    this.props.setError(fieldIssues.errors.length > 0);
                  }
                  return fieldIssues;
                }}
              >
                {fieldProps => (
                  <EDTextEdit
                    id={'urvalNamn'}
                    label="Namn"
                    onChange={fieldProps.onChange}
                    onBlur={() => {
                      fieldProps.onBlur(fieldProps.value);
                    }}
                    value={fieldProps.value || ''}
                    disabled={this.props.disableNameEdit}
                    error={
                      fieldProps.fieldErrors &&
                      fieldProps.touched &&
                      fieldProps.fieldErrors.length > 0
                    }
                    helperText={
                      fieldProps.fieldErrors &&
                      fieldProps.touched &&
                      fieldProps.fieldErrors.length > 0
                        ? fieldProps.fieldErrors[0].message
                        : undefined
                    }
                    required
                  />
                )}
              </Field>
              <Field name="visibility">
                {fieldProps => (
                  <EDRadioGroup
                    label="Synlighet"
                    value={fieldProps.value}
                    onChange={fieldProps.onChange}
                    radioDefs={this.props.availableVisibilityOptions.map(
                      visibilityOptionToRadioDef
                    )}
                  />
                )}
              </Field>
              <Field name="description">
                {fieldProps => (
                  <EDTextEdit
                    id={'description'}
                    label="Beskrivning"
                    onChange={fieldProps.onChange}
                    onBlur={() => {
                      fieldProps.onBlur(fieldProps.value);
                    }}
                    multiline
                    value={fieldProps.value || ''}
                  />
                )}
              </Field>
            </React.Fragment>
          );
        }}
      </EDForm>
    );
  }
}

export default SaveUrvalForm;
